import React from "react";

const AboutText = () => {
  return (
    <section
      id="about"
      className="bg-[#020617] flex justify-center w-full pb-24 pt-16 relative"
    >
      <div className="flex justify-center flex-col">
        <div className="relative z-0 flex items-center justify-center -space-x-2 pb-8 pt-4">
          <img
            className="relative z-10 inline-block rounded-full w-20 h-20 ring-4 ring-gray-100 object-cover"
            src="/img/baptiste.webp"
            alt="Baptiste"
            loading="lazy"
            width="80"
            height="80"
          />
          <img
            className="relative z-30 inline-block w-[100px] h-[100px] rounded-full ring-4 ring-gray-100 object-cover"
            src="/img/baptiste-2.webp"
            alt="Baptiste"
            loading="lazy"
            width="100"
            height="100"
          />
        </div>
        {/* Conteneur de texte */}
        <div className="p-5 sm:p-12 lg:p-8 flex flex-col items-center text-center">
          <h3 className="text-[14px] text-white uppercase font-bold sm:text-[16px]">
            À propos de moi
          </h3>
          <h2 className="text-[26px] font-bold text-white uppercase leading-none font-sans my-8 sm:text-[40px] xl:text-[40px] xl:max-w-4xl ">
            <span className="text-[#9BDAF2]">Accompagnement</span> sportif{" "}
            <br />
            et nutritionnel
          </h2>
          <p className=" text-white text-[16px] xl:text-[18px] xl:max-w-6xl">
            Diététicien nutritionniste et coach sportif diplômé, à mon compte
            sur Chalon-sur-Saône depuis 2020 sous la dénomination Bapt'Tips, je
            propose différentes prestations avec un objectif commun : améliorer
            le bien-être d'un maximum de personnes.
            <br /> <br />
            Bapt'Tips c'est un accompagnement individuel sportif et
            nutritionniste complet, à domicile, en salle de sport ou en
            entreprise, de manière à atteindre tes objectifs (remise en forme,
            perte de poids, prise de masse musculaire, etc.).
          </p>
          <a href="#contact">
            <button className="mt-8 px-6 py-3 text-btn bg-[#9BDAF2] text-slate-950 font-semibold rounded-md hover:bg-white transition">
              Contacte moi
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutText;
